import React, { FC } from "react";
import { RoleBasedNavigator } from "../../../components/nav/navigator";
import {
  faCalendar,
  faPieChart,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { UserRoles } from "../../../../domain/user/Role";

export const SupervisionUnityGroupNavigator: FC = () => {
  return (
    <RoleBasedNavigator
      definition={[
        {
          id: `/dashboard/supervision-unity-group`,
          label: "Resúmen",
          icon: faPieChart,
          allowedRoles: UserRoles.all,
          allowIf: () => true,
        },
        {
          id: `/dashboard/supervision-unity-group/request`,
          label: "Fecha",
          icon: faCalendar,
          allowedRoles: UserRoles.all,
          allowIf: () => true,
        },
        // {
        //   id: `/dashboard/supervision-unity-group/live`,
        //   label: "Ahora",
        //   icon: faSync,
        //   allowedRoles: UserRoles.manager,
        //   allowIf: () => true,
        // },
      ]}
    />
  );
};
